import { useState, useEffect } from "react";
import { collection, getDocs, updateDoc, doc, query, where } from "firebase/firestore";
import { db } from "../FirebaseConfig"; 
import { useNavigate } from "react-router-dom";

export default function AdminVerification({ isSigned, adminEmails, userEmail }) {
  const [pendingSellers, setPendingSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  let navigate =useNavigate()
    useEffect(() => {
      if (!adminEmails?.includes(userEmail)) {
        navigate('/');
      }
    }, [adminEmails, userEmail, navigate]);

  // Fetch pending sellers
  useEffect(() => {
    const fetchPending = async () => {
      const q = query(collection(db, "profiles"), where("verification_status", "==", "pending"));
      const snapshot = await getDocs(q);
      const sellers = snapshot.docs.map(docSnap => ({
        id: docSnap.id,
        ...docSnap.data()
      }));
      setPendingSellers(sellers);
      setLoading(false); 
    };
    fetchPending();
  }, []);

  // Approve or reject seller
  const handleDecision = async (id, decision) => {
    await updateDoc(doc(db, "profiles", id), {
      verification_status: decision
    });
    setPendingSellers(prev => prev.filter(seller => seller.id !== id));
    alert(`Seller ${decision}`);
  };

  if (loading) return <p className="text-center mt-10 text white">Loading pending verifications...</p>;

  if (pendingSellers.length === 0) {
    return <p className="text-center mt-10 text-white">No pending verifications 🎉</p>;
  }

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl text-white font-bold mb-6">Pending Seller Verifications</h1>

      <div className="grid md:grid-cols-2 gap-6">
        {pendingSellers.map((seller) => (
          <div key={seller.id} className="border rounded-lg p-4 shadow">
            <h2 className="font-bold text-lg mb-2 text-white">{seller.name || "Unnamed Seller"}</h2>
            <p className="text-sm text-gray-500 mb-4">{seller.email}</p>

            <div className="grid grid-cols-2 gap-2 mb-4">
              <div>
                <p className="font-semibold text-white text-sm mb-1">ID Card</p>
                <img src={seller.idCardUrl} alt="ID Card" className="w-full rounded border" />
              </div>
              <div>
                <p className="font-semibold text-white text-sm mb-1">Selfie with ID</p>
                <img src={seller.selfieUrl} alt="Selfie" className="w-full rounded border" />
              </div>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => handleDecision(seller.id, "approved")}
                className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
              >
                Approve
              </button>
              <button
                onClick={() => handleDecision(seller.id, "rejected")}
                className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
              >
                Reject
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
